import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Timeline} from 'primereact/timeline';
import {Skeleton} from 'primereact/skeleton';
import axios from "axios";

const ReceiptEventListComponent = (props) => {

  const {t} = props;
  const [receiptevents, setReceiptevents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [typeDict, setTypeDict] = useState([]);

  const loadLazyData = () => {
    setLoading(true);
    apiCall(
      'get',
      '/api/v2/receipt-event?sort=id&direction=desc&search[receipt][operator]==&search[receipt][value]=' + props.receiptId
    )
      .then(response => {
        setReceiptevents(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const getEventTypeValue = (rowData) => {
    if (!rowData) {
      return null;
    }
    if (rowData.type === 'APPROVED_FOR_PAYMENT' && rowData.approved_for_payment_date) {
      return window.App.formatDateValue(rowData.approved_for_payment_date);
    }
    if (rowData.type === 'PAID' && rowData.paid_amount !== null && rowData.paid_amount !== undefined) {
      return `${rowData.paid_amount}${rowData.receipt?.currency ? ` ${rowData.receipt.currency}` : ''}`;
    }
    return null;
  };

  const typeTranslate = (rowData) => {
    const typeObj = typeDict.find(item => item.key === rowData.type);
    const label = typeObj ? typeObj.value : rowData.type;
    const severityClass = rowData.type === 'COMMENT' ? 'p-tag-warning' : 'p-tag-success';
    return (
      <span
        className={`p-tag ${severityClass}`}
        style={{
          whiteSpace: 'nowrap',
          display: 'inline-flex',
          alignItems: 'center'
        }}
      >
        {label}
      </span>
    );
  };

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/dictionary/receipt-event-type', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
    .then(response => {
      setTypeDict(response.data.data)
    })
    .catch(error => {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    })
  }, [])

  useEffect(() => {
    loadLazyData();
  }, [props.receiptId, window.App.state.rerenderReceiptEventList])

  if (loading) {
    return (
      <div className="p-py-2" aria-label={t('loading')}>
        {[0, 1, 2].map(index => (
          <div key={index} className="p-d-flex p-ai-start p-mb-4">
            <Skeleton shape="circle" size="2rem" className="p-mr-3" />
            <div style={{flex: 1}}>
              <Skeleton width="9rem" height="1.25rem" className="p-mb-2" />
              <Skeleton width={index === 1 ? '55%' : '75%'} height="0.9rem" className="p-mb-2" />
              <Skeleton width="35%" height="0.75rem" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <>
      <Timeline value={receiptevents}
                align="left"
                marker={(rowData) => {
                  return typeTranslate(rowData)
                }}
                opposite={(rowData) => {
                  return (
                    <small className="p-text-secondary">
                      {window.App.formatDateValue(rowData.date)}
                    </small>
                  )
                }}
                content={(rowData) => {
                  const typeValue = getEventTypeValue(rowData);
                  return (
                    <div className="p-mb-3">
                      <div className="p-grid">
                          {rowData.created_by?.name ? (
                              <div className="p-col-12">
                                  {t('createdBy')}: <strong>{rowData.created_by.name}</strong>
                              </div>
                          ) : null}
                        {rowData.note && (
                          <div className="p-col-12">
                            {t('comment')}: <strong>{rowData.note || '-'}</strong>
                          </div>
                        )}
                        {typeValue && (
                          <div className="p-col-12">
                            <strong>{typeValue}</strong>
                          </div>
                        )}
                        {/* <div className="p-col-12 p-text-right">
                          {actionBodyTemplate(rowData)}
                        </div> */}
                      </div>
                    </div>
                  )
                }}
      />
      {/* <Paginator first={lazyParams.first}
                 rows={rows}
                 totalRecords={totalRecords}
                 onPageChange={onPage}
                 rowsPerPageOptions={[
                   Number(process.env.REACT_APP_LIST_ROW_OP1),
                   Number(process.env.REACT_APP_LIST_ROW_OP2),
                   Number(process.env.REACT_APP_LIST_ROW_OP3),
                   Number(process.env.REACT_APP_LIST_ROW_OP4)
                 ]}
      /> */}
    </>
  )
}
export default withTranslation('common')(ReceiptEventListComponent);
